import gql from 'graphql-tag'

const CHECKOUT = gql`
  mutation($cartId: String!, $provider: String!, $selectedShipping: SelectedShipping) {
    checkout(cart_id: $cartId, provider: $provider, selected_shipping: $selectedShipping) {
      provider
      url
    }
  }
`

export {
  CHECKOUT
}
